import { useRef } from 'react';
import { useNavigate } from 'react-router';

import { incidentDetailRoute } from '@/features/shared/routes';
import type { Incident, PortalCall } from '@/signalr/contracts';
import { createIncident } from '@ngsos/portal-core/commands';
import { resolveIncidentForCall } from '@ngsos/portal-core/incidents';
import { CallNotificationListComponentItem } from './CallNotificationListComponentItem';

export type CallNotificationListComponentProps = {
  callNotifications: readonly PortalCall[];
  incidents: readonly Incident[];
};

export function CallNotificationListComponent({ callNotifications, incidents }: CallNotificationListComponentProps) {
  const navigate = useNavigate();
  const createIncidentInProgressRef = useRef(false);

  const createNewIncident = async (call: PortalCall) => {
    if (createIncidentInProgressRef.current) {
      return;
    }

    createIncidentInProgressRef.current = true;
    try {
      const requestedIncidentId = crypto.randomUUID();
      await createIncident(requestedIncidentId, [call.callerPhoneNumber]);
      void navigate(incidentDetailRoute(requestedIncidentId));
    } finally {
      createIncidentInProgressRef.current = false;
    }
  };

  return (
    <div className="call-notifications-list">
      {callNotifications.map((call) => (
        <CallNotificationListComponentItem
          key={call.id}
          call={call}
          incidentId={resolveIncidentForCall(call, incidents)?.incidentId ?? null}
          onCreateNewIncident={createNewIncident}
        />
      ))}
    </div>
  );
}
